import { WebApiService } from '../../plugins/webApiService'
import { Events } from '../../plugins/events'
import { SendRequestModel } from '../../plugins/models/SendRequestModel'
import UserProjectReportRequest from '../../statistic/i-service/models/request/UserProjectReportRequest';
import ProjectUserReportRequest from '../../statistic/i-service/models/request/ProjectUserReportRequest';
import ProjectAllUsersReportRequest from '../../statistic/i-service/models/request/ProjectAllUsersReportRequest';
import PerformerTaskDaysRequest from '../../statistic/i-service/models/request/PerformerTaskDaysRequest';
import WsResponseModelT from '../../schema-builder-server/models/WsResponseModelT';
import UserProjectReportResponse from '../../statistic/i-service/models/response/UserProjectReportResponse';
import ProjectUserReportResponse from '../../statistic/i-service/models/response/ProjectUserReportResponse';
import ProjectAllUsersReportResponse from '../../statistic/i-service/models/response/ProjectAllUsersReportResponse';
import PerformerTaskDaysResponse from '../../statistic/i-service/models/response/PerformerTaskDaysResponse';

export default class StatisticProjectService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	UserProjectReportEvent = new Events<WsResponseModelT<Array<UserProjectReportResponse>>>();
	ProjectUserReportEvent = new Events<WsResponseModelT<Array<ProjectUserReportResponse>>>();
	ProjectAllUsersReportEvent = new Events<WsResponseModelT<Array<ProjectAllUsersReportResponse>>>();
	PerformerTaskDaysReportEvent = new Events<WsResponseModelT<Array<PerformerTaskDaysResponse>>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('StatisticProjectService', 'UserProjectReport', 'Main', (res: WsResponseModelT<Array<UserProjectReportResponse>>) => {
			self.UserProjectReportEvent.trigger(res);
		});
		webApiService.on('StatisticProjectService', 'ProjectUserReport', 'Main', (res: WsResponseModelT<Array<ProjectUserReportResponse>>) => {
			self.ProjectUserReportEvent.trigger(res);
		});
		webApiService.on('StatisticProjectService', 'ProjectAllUsersReport', 'Main', (res: WsResponseModelT<Array<ProjectAllUsersReportResponse>>) => {
			self.ProjectAllUsersReportEvent.trigger(res);
		});
		webApiService.on('StatisticProjectService', 'PerformerTaskDaysReport', 'Main', (res: WsResponseModelT<Array<PerformerTaskDaysResponse>>) => {
			self.PerformerTaskDaysReportEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Отчет по пользователю за проект
	 */
	async UserProjectReport(request: UserProjectReportRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'StatisticProjectService',
			Method: 'UserProjectReport',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отчет по проектам для пользователя
	 */
	async ProjectUserReport(request: ProjectUserReportRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'StatisticProjectService',
			Method: 'ProjectUserReport',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отчет по проектам для всех пользователей
	 */
	async ProjectAllUsersReport(request: ProjectAllUsersReportRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'StatisticProjectService',
			Method: 'ProjectAllUsersReport',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отчет по исполнителям в разбивки по дням
	 */
	async PerformerTaskDaysReport(request: PerformerTaskDaysRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'StatisticProjectService',
			Method: 'PerformerTaskDaysReport',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Отчет по пользователю за проект
	 */
	async userProjectReportAsync(request: UserProjectReportRequest): Promise<Array<UserProjectReportResponse>> {
		return new Promise<Array<UserProjectReportResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'StatisticProjectService',
				Method: 'UserProjectReport',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<UserProjectReportResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<UserProjectReportResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отчет по проектам для пользователя
	 */
	async projectUserReportAsync(request: ProjectUserReportRequest): Promise<Array<ProjectUserReportResponse>> {
		return new Promise<Array<ProjectUserReportResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'StatisticProjectService',
				Method: 'ProjectUserReport',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<ProjectUserReportResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ProjectUserReportResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отчет по проектам для всех пользователей
	 */
	async projectAllUsersReportAsync(request: ProjectAllUsersReportRequest): Promise<Array<ProjectAllUsersReportResponse>> {
		return new Promise<Array<ProjectAllUsersReportResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'StatisticProjectService',
				Method: 'ProjectAllUsersReport',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<ProjectAllUsersReportResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ProjectAllUsersReportResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отчет по исполнителям в разбивки по дням
	 */
	async performerTaskDaysReportAsync(request: PerformerTaskDaysRequest): Promise<Array<PerformerTaskDaysResponse>> {
		return new Promise<Array<PerformerTaskDaysResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'StatisticProjectService',
				Method: 'PerformerTaskDaysReport',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Array<PerformerTaskDaysResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<PerformerTaskDaysResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}